import { render, staticRenderFns } from "./createProduto.vue?vue&type=template&id=ccfa19de&scoped=true&"
import script from "./createProduto.vue?vue&type=script&lang=js&"
export * from "./createProduto.vue?vue&type=script&lang=js&"
import style0 from "./createProduto.vue?vue&type=style&index=0&id=ccfa19de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfa19de",
  null
  
)

export default component.exports